"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardViewButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const LeaderboardViewButton = ({ label, viewType, standingTabs, setStandingTabs, factor }) => {
    const isActive = standingTabs === viewType;
    return ((0, jsx_runtime_1.jsx)(material_1.Button, { onClick: () => setStandingTabs(viewType), sx: {
            padding: 2 * factor,
            color: isActive ? 'secondary.main' : 'text.primary',
            backgroundColor: isActive ? 'primary.light' : 'transparent',
            borderBottom: isActive ? 2 : 0,
            borderColor: 'secondary.main',
            borderRadius: 2
        }, children: label }));
};
exports.LeaderboardViewButton = LeaderboardViewButton;
